






















import { Component } from "vue-property-decorator";
import { Constants, Events } from "@/common/global.ts";

import BaseView from "@/common/base-view.ts";
import UIBackground from "@/views/ui/Background.vue";

@Component({
    components: {
        UIBackground,
    },
})
export default class App extends BaseView {

    /**
     * [created description]
     *
     * @return {[type]} [description]
     */
    public created() {
        this.globalize("App", this);
    }

}
